import React from 'react';
import dayjs from 'dayjs';
import Select from "react-select";
import { optionsTransportOrderStatus } from '../../../common/constant';

export const TransportOrderTableDesktop = ({
    data,
    sumaryCuisine,
    rowsPerPage,
    handleChangeRowsPerPage,
    headCellsListTransportOrder,
    handleRequestSort,
    order,
    orderBy,
    totalItemCount,
    setRowsPerPage,
    page,
    handleChangePage,
    configLocal,
    getListTransportOrderManagement,
    searchData,
    currentUser,
    herdsman,
    setOpenChangeStatusDialog,
    openConfirmDialog,
    openChangeDeliveryDialog,
    setOpenCancelDeliveryDialog,
    setOpenAssignToMeDialog,
    setOpenAssignDeliveryDialog,
    styles,
    DataTableSarang
}) => {
    return (
        <>
            <DataTableSarang
            sumary={sumaryCuisine}
            rowsPerPage={rowsPerPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            headCells={headCellsListTransportOrder}
            handleRequestSort={handleRequestSort}
            order={order}
            orderBy={orderBy}
            totalItemCount={totalItemCount}
            setRowsPerPage={setRowsPerPage}
            pageIndex={page}
            handleChangePage={handleChangePage}
            configLocal={configLocal}
            getList={getListTransportOrderManagement}
            searchData={searchData}
        >
            <tbody>
                {(data && data.length > 0) ? (
                    data.map((row, rowIndex) => (
                        <tr key={rowIndex}>
                            <td>{row?.transportCode}</td>
                            <td><span className={row?.receiptTime === 2 ? "text-primary" : "text-danger"}>{dayjs(row?.orderDate).format("DD/MM/YYYY")}</span></td>
                            <td><span className={row?.receiptTime === 2 ? "text-primary" : "text-danger"}>{row?.receiptTime === 1 ? "Sáng" : (row?.receiptTime === 2 ? "Trưa" : "Chiều")}</span></td>
                            <td><span>{row?.districtName}</span></td>
                            <td><span>{row?.communeName}</span></td>
                            <td><span>{row?.address}</span></td>
                            <td><span>{row?.herdsmanReceiptName}</span></td>
                            <td><span><a href={`tel:${row?.herdsmanReceiptPhone}`}>{row?.herdsmanReceiptPhone}</a></span></td>
                            <td><span>{row?.quatity}</span></td>
                            <td>
                                {row?.allowChangeStatus ? (
                                    <span>
                                        <Select
                                            value={row?.status ? { label: row.statusName, value: row.status } : null}
                                            placeholder="Chọn Trạng thái"
                                            onChange={(data) => {
                                                setOpenChangeStatusDialog(true);
                                                openConfirmDialog({ ...row, orderStatusChange: data.value, orderStatusNameChange: data.label });
                                            }}
                                            options={optionsTransportOrderStatus.filter(x => x.value >= (row?.status || 0))}
                                            noOptionsMessage={() => "Không tồn tại"}
                                            menuPortalTarget={document.body}
                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                        />
                                    </span>
                                ) : (
                                    <span>{row?.statusName}</span>
                                )}
                            </td>
                            <td>
                                {row?.deliveries && Array.isArray(row.deliveries) && row.deliveries.length > 0 ? (
                                    <div style={{ gap: '10px', display: 'flex', alignItems: 'center' }}>
                                        {(row?.status === 40 || row?.status === 45) && (
                                            <>
                                                <i className="far fa-edit text-primary" title="Đổi người giao" style={{ cursor: 'pointer' }} onClick={() => openChangeDeliveryDialog(row)}></i>
                                                <li title="Hủy" className="far fa-times-circle text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                                                    setOpenCancelDeliveryDialog(true);
                                                    openConfirmDialog(row);
                                                }}></li>
                                            </>
                                        )}
                                        <span>{row.deliveries[0]?.herdsmanDeliverName}
                                            {row.deliveries[0]?.herdsmanDeliverPhone && (
                                                <>
                                                    <a href={`tel:${row.deliveries[0].herdsmanDeliverPhone}`}> - {row.deliveries[0].herdsmanDeliverPhone}</a>
                                                    <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table phone ml-2" data-toggle="tooltip" data-placement="top" title="Gọi" onClick={() => { window.location.href = `tel:${row.deliveries[0].herdsmanDeliverPhone}`; }}>
                                                        <i className="fas fa-phone"></i>
                                                    </button>
                                                </>
                                            )}
                                        </span>
                                    </div>
                                ) : (
                                    <>
                                        {(row?.status === 40 || row?.status === 50) && (
                                            <div className={styles.delivery_container}>
                                                <span className={styles.assign_to_me} onClick={() => {
                                                    setOpenAssignToMeDialog(true);
                                                    openConfirmDialog({ ...row, herdsmanDeliverId: currentUser?.herdsmanId });
                                                }}>Nhận giao</span>
                                                {row?.allowAssign && (
                                                    <Select
                                                        placeholder="Chọn người giao"
                                                        onChange={(data) => {
                                                            setOpenAssignDeliveryDialog(true);
                                                            openConfirmDialog({ ...row, herdsmanDeliverId: data.value, herdsmanDeliverName: data.label });
                                                        }}
                                                        options={(herdsman || []).map(item => ({ label: item?.name, value: item?.id }))}
                                                        noOptionsMessage={() => "Không tồn tại"}
                                                        menuPortalTarget={document.body}
                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </>
                                )}
                            </td>
                            <td><span>{row?.description}</span></td>
                        </tr>
                    ))
                ) : (
                    <tr><td colSpan={12}>Chưa có dữ liệu</td></tr>
                )}
            </tbody>
        </DataTableSarang>
        </>
    );
};

export const TransportOrderTableMobile = ({
    data,
    totalItemCount,
    rowsPerPage,
    page,
    handleChangePage,
    headCellsListTransportOrder,
    getListTransportOrderManagement,
    searchData,
    setOrder,
    setOrderBy,
    configLocal,
    sumaryCuisine,
    currentUser,
    herdsman,
    setOpenChangeStatusDialog,
    openConfirmDialog,
    openChangeDeliveryDialog,
    setOpenCancelDeliveryDialog,
    setOpenAssignToMeDialog,
    setOpenAssignDeliveryDialog,
    styles,
    MobileHeaderSarang,
    DataTablePagination
}) => {
    return (
        <div className="accrodion-regular">
            <MobileHeaderSarang
                headCell={headCellsListTransportOrder}
                handleSortChange={(sortExpression) => getListTransportOrderManagement(page + 1, rowsPerPage, sortExpression, searchData)}
                setOrder={setOrder}
                setOrderBy={setOrderBy}
                configLocal={configLocal}
                getList={getListTransportOrderManagement}
                searchData={searchData}
            />
            <div id="accordion">
                <div className="card">
                    <div className="d-flex align-items-center">
                        <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }} data-toggle="collapse" aria-expanded="false">
                            <div className="d-flex w-100 flex-column">
                                {sumaryCuisine?.sumaryShipperCuisine ? (
                                    <div>Đã nhận giao: <b>{sumaryCuisine?.sumaryShipperCuisine}</b> - <span className="text-primary">Trưa: <b>{sumaryCuisine?.sumaryShipperLunch}</b></span> - <span className="text-danger">Chiều: <b>{sumaryCuisine?.sumaryShipperDinner}</b></span></div>
                                ) : (
                                    sumaryCuisine?.sumaryCuisineOrder ? (
                                        <div>Tổng SL đơn: <b>{sumaryCuisine?.sumaryCuisineOrder}</b> - <span className="text-primary">Trưa: <b>{sumaryCuisine?.sumaryLunchOrder}</b></span> - <span className="text-danger">Chiều: <b>{sumaryCuisine?.sumaryDinnerOrder}</b></span></div>
                                    ) : null
                                )}
                                <hr />
                                <div>Tổng suất ăn: <b>{sumaryCuisine?.sumaryCuisineQuatity}</b> - <span className="text-primary">Trưa: <b>{sumaryCuisine?.sumaryLunch}</b></span> - <span className="text-danger">Chiều: <b>{sumaryCuisine?.sumaryDinner}</b></span></div>
                            </div>
                        </div>
                    </div>
                </div>
                {(data && data.length > 0) ? (
                    data.map((item, index) => (
                        <div className="card" key={index}>
                            <div className="d-flex align-items-center" id={`heading-${item?.id}`}>
                                <div className="list-group-item list-group-item-action flex-column align-items-start collapsed" style={{ border: "none" }} data-toggle="collapse" data-target={`#collapse-${item?.id}`} aria-expanded="false" aria-controls={`collapse-${item?.id}`}>
                                    <div className="d-flex w-100 justify-content-between">
                                        <h5 className={item?.receiptTime === 2 ? "mb-1 text-primary" : "mb-1 text-danger"}>{item?.transportCode}</h5>
                                        <small className={item?.receiptTime === 2 ? "d-flex align-items-center text-primary" : "d-flex align-items-center text-danger"}>
                                            {item?.receiptTime === 1 ? "Sáng" : (item?.receiptTime === 2 ? "Trưa" : "Chiều")}/
                                            {dayjs(item?.orderDate).format("DD/MM/YYYY")}
                                        </small>
                                    </div>
                                    <div className='row'>
                                        <div className='col-6 text-left'>
                                            <div className='mt-0'><b>Quận/ huyện:</b></div>
                                            <span>{item?.districtName}</span>
                                            <div className='mt-0'><b>Phường/xã:</b></div>
                                            <span>{item?.communeName}</span>
                                            <div className='mt-0'><b>Địa chỉ:</b></div>
                                            <span>{item?.address}</span>
                                        </div>
                                        <div className='col-6 text-left'>
                                            <div className='mt-2'><b>Số lượng: </b> {item?.quatity}</div>
                                            <div className='mt-0'>
                                                <b>Tình trạng: </b>
                                                {item?.allowChangeStatus ? (
                                                    <span>
                                                        <Select
                                                            value={item?.status ? { label: item.statusName, value: item.status } : null}
                                                            placeholder="Chọn Trạng thái"
                                                            onChange={(data) => {
                                                                setOpenChangeStatusDialog(true);
                                                                openConfirmDialog({ ...item, orderStatusChange: data.value, orderStatusNameChange: data.label });
                                                            }}
                                                            options={optionsTransportOrderStatus.filter(x => x.value >= (item?.status || 0) && x.value !== item?.status)}
                                                            noOptionsMessage={() => "Không tồn tại"}
                                                            menuPortalTarget={document.body}
                                                            styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                        />
                                                    </span>
                                                ) : (
                                                    <span>{item?.statusName}</span>
                                                )}
                                            </div>
                                            <div className='mt-2'>
                                                <b>Ace giao: </b>
                                                {item?.deliveries && Array.isArray(item.deliveries) && item.deliveries.length > 0 ? (
                                                    <div style={{ gap: '10px', display: 'flex', alignItems: 'center' }}>
                                                        {(item?.status === 40 || item?.status === 45) && (
                                                            <>
                                                                <i className="far fa-edit text-primary" title="Sửa" onClick={() => openChangeDeliveryDialog(item)}></i>
                                                                <li title="Hủy" className="far fa-times-circle text-danger" style={{ cursor: 'pointer' }} onClick={() => {
                                                                    setOpenCancelDeliveryDialog(true);
                                                                    openConfirmDialog(item);
                                                                }}></li>
                                                            </>
                                                        )}
                                                        <span>{item.deliveries[0]?.herdsmanDeliverName}
                                                            {item.deliveries[0]?.herdsmanDeliverPhone && (
                                                                <>
                                                                    <a href={`tel:${item.deliveries[0].herdsmanDeliverPhone}`}> - {item.deliveries[0].herdsmanDeliverPhone}</a>
                                                                    <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table phone ml-2" data-toggle="tooltip" data-placement="top" title="Gọi" onClick={() => { window.location.href = `tel:${item.deliveries[0].herdsmanDeliverPhone}`; }}>
                                                                        <i className="fas fa-phone"></i>
                                                                    </button>
                                                                </>
                                                            )}
                                                        </span>
                                                    </div>
                                                ) : (
                                                    <>
                                                        {(item?.status === 40 || item?.status === 50) && (
                                                            <div className={styles.delivery_container_mb}>
                                                                <div className={styles.assign_to_me_mb} onClick={() => {
                                                                    setOpenAssignToMeDialog(true);
                                                                    openConfirmDialog({ ...item, herdsmanDeliverId: currentUser?.herdsmanId });
                                                                }}>Nhận giao</div>
                                                                {item?.allowAssign && (
                                                                    <Select
                                                                        placeholder="Ae/Ce giao"
                                                                        onChange={(data) => {
                                                                            setOpenAssignDeliveryDialog(true);
                                                                            openConfirmDialog({ ...item, herdsmanDeliverId: data.value, herdsmanDeliverName: data.label });
                                                                        }}
                                                                        options={(herdsman || []).map(item => ({ label: item?.name, value: item?.id }))}
                                                                        noOptionsMessage={() => "Không tồn tại"}
                                                                        menuPortalTarget={document.body}
                                                                        styles={{ menuPortal: base => ({ ...base, zIndex: 9999 }) }}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <i className="fas fa-angle-down p-2"></i>
                            </div>
                            <div id={`collapse-${item?.id}`} className="collapse" aria-labelledby={`heading-${item?.id}`} data-parent="#accordion">
                                <div className="card-body text-left">
                                    <div className='row'>
                                        <div className='col-12'>
                                            <div className='mt-0'><b>Người nhận:</b></div>
                                            <span>{item?.herdsmanReceiptName}</span>
                                            <div className='mt-2'><b>Điện thoại:</b></div>
                                            {item?.herdsmanReceiptPhone ? (
                                                <span>
                                                    <a href={`tel:${item.herdsmanReceiptPhone}`}>{item.herdsmanReceiptPhone}</a>
                                                    <button className="d-inline-block btn btn-sm btn-outline-light custom-button-table phone ml-2" data-toggle="tooltip" data-placement="top" title="Gọi" onClick={() => { window.location.href = `tel:${item.herdsmanReceiptPhone}`; }}>
                                                        <i className="fas fa-phone"></i>
                                                    </button>
                                                </span>
                                            ) : <br />}
                                        </div>
                                    </div>
                                    <div className='mt-0'><b>Ghi chú:</b></div>
                                    <span>{item?.description}</span>
                                </div>
                            </div>
                        </div>
                    ))
                ) : <div className="card">Chưa có dữ liệu</div>}
            </div>
            {totalItemCount > 0 && (
                <DataTablePagination
                    totalItemCount={totalItemCount}
                    rowsPerPage={rowsPerPage}
                    pageIndex={page + 1}
                    handleChangePage={handleChangePage}
                />
            )}
        </div>
    );
};
